import React from 'react';
import { useHistory } from 'react-router-dom';

import SearchField from '@app/components/Forms/SearchField/SearchField';
import '@app/scss/components/find-vet.scss';

interface FindVetProps {
	customButtonText?: string;
	classSearchBtn?: string;
	setValid?: any;
}

const FindVet: React.FC<FindVetProps> = ({ customButtonText, classSearchBtn, setValid = true}) => {
	const [inputValue, setInputValue] = React.useState('');
	const history = useHistory();

	const handle = () => {
		history.push(`/results/${inputValue.replace(/\s/g, '')}`);
	};

	return (
		<SearchField
			placeholder="Enter ZIP or Postal Code"
			value={inputValue || ''}
			setValue={setInputValue}
			classSearchBtn={classSearchBtn}
			handleSearch={handle}
			customButtonText={customButtonText}
			setValid={setValid}
		/>
	);
};

export default FindVet;
